import { createContext } from 'react'

import { NonprofitsContextType } from './NonprofitsContext.types'

export const NonprofitsContext = createContext<NonprofitsContextType | undefined>(undefined)
